import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function ProfileFilled({ width, height }) {
  return (
    <>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
      >
        <G clipPath="url(#clip0_5535_8988)">
          <Path
            d="M3.78125 4.21875C3.78125 6.54509 5.67366 8.4375 8 8.4375C10.3263 8.4375 12.2188 6.54509 12.2188 4.21875C12.2188 1.89241 10.3263 0 8 0C5.67366 0 3.78125 1.89241 3.78125 4.21875Z"
            fill="#368665"
          />
          <Path
            d="M12.2188 4.21875C12.2188 1.89241 10.3263 0 8 0V8.4375C10.3263 8.4375 12.2188 6.54509 12.2188 4.21875Z"
            fill="#368665"
          />
          <Path
            d="M0.96875 15.5312C0.96875 15.7903 1.17841 16 1.4375 16H14.5625C14.8216 16 15.0312 15.7903 15.0312 15.5312C15.0312 12.1713 12.2975 9.375 8.9375 9.375H7.0625C3.7025 9.375 0.96875 12.1713 0.96875 15.5312Z"
            fill="#368665"
          />
          <Path
            d="M8.9375 9.375H8V16H14.5625C14.8216 16 15.0313 15.7903 15.0313 15.5313C15.0313 12.1713 12.2975 9.375 8.9375 9.375Z"
            fill="#368665"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_5535_8988">
            <Rect width={width} height={height} fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </>
  );
}
